import React from 'react';
import { makeStyles } from 'design-system/styles';
import CircularProgress from 'design-system/CircularProgress';

const useStyles = makeStyles({
  container: {
    marginTop: 40,
    margin: '0 auto',
    textAlign: 'center',
  },
});

const QMLoadingPage: React.FC<{ className?: string }> = props => {
  const classes = useStyles();
  return (
    <div className={[props.className, classes.container].join(' ')}>
      <CircularProgress />
    </div>
  );
};

export default QMLoadingPage;
